import { CHART_COLORS } from '@/constants/chartColors'

export function getChartColor(index: number, opacity?: string): string {
  const opacityValue = opacity ? `, ${opacity}` : ''

  return `rgba(${Object.values(CHART_COLORS)[index % Object.keys(CHART_COLORS).length]}${opacityValue})`
}
